/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AnyAction } from 'redux';
import { getNextPosts, getPosts } from '../../redux/slices/analytics/postsList';
import { PostShortAnalytics } from '../../components/postShortAnalytics';
import IsLoadingIndicator from '../../components/isLoadingIndicator';
import { Pagination } from '../../components/pagination';
import { InView } from 'react-intersection-observer';
import { getLocationDetails } from '../../redux/slices/location/locationDetails';
import AnalyticsPagesLayout from '@/components/analyticsPagesLayout';
import {
  CAMPAIGN_ANALYTICS_LABEL,
  POST_PERFORMANCE_LABEL,
  POSTS_ANALYTICS_LABEL,
  POSTS_ANALYTICS_NAVBAR_ACTIONS
} from '../dashboard/config';
import PostAnalytics from './sections/postAnalytics';
import PostPerformance from '../allAnalytics/sections/postPerformance';
import CampaignAnalysis from '../allAnalytics/sections/campaignAnalytics';

const ShortAnalytics: React.FC = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const dispatch = useDispatch();
  const { locationslug } = useParams();
  useEffect(() => {
    if (locationslug ?? '') {
      dispatch(getLocationDetails(locationslug) as unknown as AnyAction);
    }
  }, [dispatch, locationslug]);
  const getPagePosts = (page: number): void => {
    window.scrollTo(0, 0);
    dispatch(getNextPosts(page) as unknown as AnyAction);
    setPageNumber(pageNumber + 1);
  };

  const { isUpdating, currentPagePosts, isLoading, rowsNumber, count } =
    useSelector((state: any) => state.postsList);
  useEffect(() => {
    dispatch(
      getPosts(locationslug, 'ready', {
        has_been_published_on_platform: 'True',
        ordering: '-latest_upload_to_platform_timestamp',
        analytics: 'True'
      }) as unknown as AnyAction
    );
  }, [dispatch]);
  return (
    <Container>
      <div className="m-2" />
      <AnalyticsPagesLayout
        actions={POSTS_ANALYTICS_NAVBAR_ACTIONS}
        tabs={{
          [POSTS_ANALYTICS_LABEL]: <PostAnalytics />,
          [POST_PERFORMANCE_LABEL]: <PostPerformance />,
          [CAMPAIGN_ANALYTICS_LABEL]: <CampaignAnalysis />
        }}
      />
    </Container>
  );
};
export default ShortAnalytics;
